import { Constants } from '@fff-web/fff-payments';
import { trackEvent, trackPageLoad } from '@fff-web/fff-analytics';
import { IUserInfo } from 'packages/libs/fff-utilities/src/interfaces';
import { useEffect } from 'react';

export const PRO_RATED_UPGRADE_MESSAGES = {
  trackName: 'Prorated Upgrade Clicked CTA',
  ctaName: 'YES, UPGRADE ME - $150',
  proRatedUpgradeId: 'pro-rated-upgrade-id',
  submitButtonId: 'pro-rated-upgrade-button-id',
  experimentView: 'Experiment Viewed',
  subscriptionError: 'subscription Error: ',
  thanksPage: '/upgrade-thanks',
  experienceLabel: 'Prorated Upgrade',
};

export const trackSubscriptionUpgrade = ({
  ctaName,
  newPlan,
  previousPlan,
  trackName,
}: {
  ctaName: string;
  trackName: string;
  newPlan: keyof typeof Constants;
  previousPlan: keyof typeof Constants;
}) => {
  trackEvent({
    ctaName,
    trackName,
    properties: {
      name: 'Subscription Upgrade',
      plan_selected: newPlan,
      status: 'success',
    },
  });
  trackEvent({
    ctaName,
    trackName,
    properties: {
      name: 'Upgrade Logs',
      newPlan,
      previousPlan,
    },
  });
  trackEvent({
    ctaName,
    trackName,
    properties: {
      name: 'Upgrade Completed',
      newPlan,
      previousPlan,
    },
  });
};

enum AvailableCouponCodes {
  PRORATED_UPGRADE_CA = 'prorated-upgrade-ca',
  PRORATED_UPGRADE_GB = 'prorated-upgrade-gb',
  PRORATED_UPGRADE_US = 'prorated-upgrade-us',
}

export const validateSeasonalMembership = (userInfo: IUserInfo) => {
  return userInfo?.user?.planCode === Constants.SEASONAL_PLAN_CODE;
};

export const resolveCouponCodeByCountry = (userInfo: IUserInfo) => {
  const shipCountry = userInfo?.user?.shippingCountry;
  const shipState = userInfo?.user?.shippingState;
  const isSeasonalMember = validateSeasonalMembership(userInfo);
  let couponCode = '';

  if (isSeasonalMember) {
    if (shipCountry === 'CA') {
      couponCode = 'prorated-upgrade-ca';
    } else if (shipCountry === 'GB') {
      couponCode = AvailableCouponCodes.PRORATED_UPGRADE_GB;
    } else if (shipCountry === 'US') {
      if (['AK', 'HI', 'PR'].includes(shipState)) {
        couponCode = AvailableCouponCodes.PRORATED_UPGRADE_CA;
      } else {
        couponCode = AvailableCouponCodes.PRORATED_UPGRADE_US;
      }
    }
  }

  return couponCode;
};

export const useTrackProRatedUpgrade = () => {
  useEffect(() => {
    trackPageLoad({
      pathName: PRO_RATED_UPGRADE_MESSAGES.thanksPage,
      properties: {
        experience: PRO_RATED_UPGRADE_MESSAGES.experienceLabel,
      },
    });
  }, []);
};
